import { PortableTextBlock } from '@portabletext/react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { Minus } from './icons/Minus';
import { Plus } from './icons/Plus';
import { Accordion } from './rebrand/Accordion';
import CustomPortableText from './rebrand/CustomPortableText';

type Props = {
  className?: string;
  contentClassName?: string;
  iconClassName?: string;
  items: {
    heading: string;
    content: PortableTextBlock | PortableTextBlock[];
  }[];
  titleClassName?: string;
};

export const AccordionItems = ({ className, contentClassName, iconClassName, items, titleClassName }: Props) => {
  return items.map((item) => (
    <Accordion
      className={twMerge(clsx('border-t border-grey-100 py-24 md:py-32', className))}
      title={
        <h3 className={twMerge(clsx('text-md font-bold text-grey-500 md:text-xl', titleClassName))}>{item.heading}</h3>
      }
      key={item.heading}
      iconOverrides={{
        maximizeIcon: <Plus className={iconClassName} />,
        minimizeIcon: <Minus className={iconClassName} />,
      }}
    >
      <div
        className={twMerge(
          clsx('[&_ol]:pl-0 [&_p]:text-md [&_p]:font-normal [&_p]:leading-normal [&_p]:md:text-lg', contentClassName),
        )}
      >
        <CustomPortableText content={item.content} />
      </div>
    </Accordion>
  ));
};
